import { CommonModule } from '@angular/common';
import { Component, HostListener, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import lottie from 'lottie-web';
import { Observable } from 'rxjs';
import { IMenuItem } from 'src/app/models/menu-item.model';
import { SitePageService } from 'src/app/services/site-page.service';

@Component({
  selector: 'app-header',
  imports: [ CommonModule, RouterModule ],
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  private sitePageService = inject(SitePageService);

  public menus : Observable<IMenuItem[]>  = this.sitePageService.getMenus();

  ngOnInit() {
    var el = document.getElementById("logo-menu");
    if (el) {
      lottie.loadAnimation({
            container: el,
            path: "assets/json/inst-logo-01.json",
            renderer: "svg",
            loop: true,
            autoplay: true,
            name: "top nav logo animation"
        })
      }
  }

  toggleMenu(){
    document.getElementById('main-nav')?.classList.toggle("menu-open");
  }

  @HostListener('window:resize')
  onResize() {
    document.getElementById('main-nav')?.classList.remove("menu-open");
  }

}
